import { Component, inject, OnInit, signal } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AppShellComponent, FrameworkService, TenantManagementStubService } from '@optima-stride-ai/optima-app-framework';
import { benzaitenTenants } from '../assets/tenants';
import { IconSetService } from '@coreui/icons-angular';
import { iconSubset, ToastContainerComponent } from '@optima-stride-ai/optima-components';

import { DefaultModalComponent } from "./modal/modal-component/modal.component";
import { RouterOutlet } from '@angular/router';
import { environment } from './environments/environment.uat';


@Component({
  selector: 'app-root',
  imports: [AppShellComponent, ToastContainerComponent, DefaultModalComponent, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.sass'
})
export class App {
  private iconSetService: IconSetService = inject(IconSetService);
  private titleService = inject(Title);

  constructor() {
    this.iconSetService.icons = { ...iconSubset };
    this.titleService.setTitle(environment.displayName);
  }
}
